import React from 'react';

const FacetAdjustIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 4L7 4M7 4C7 2.89543 6.10457 2 5 2C3.89543 2 3 2.89543 3 4M7 4C7 5.10457 6.10457 6 5 6C3.89543 6 3 5.10457 3 4M3 4L0.5 4M15.5 12L13 12M13 12C13 10.8954 12.1046 10 11 10C9.89543 10 9 10.8954 9 12M13 12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12M9 12H0.5"
        stroke="#14607A"
        strokeWidth="1.6"
      />
    </svg>
  );
};

export default FacetAdjustIcon;
